/*
 * Default translation prefix
 */
const keyPrefix = "filtersForm";
export default keyPrefix;
